import React from "react"
import { Container, Header, Icon, Responsive } from "semantic-ui-react"
import styled from "styled-components"
import OrganizationAutosuggest from "./../../components/organization-autosuggest"

const Home = () => (
	<HomeContainer>
		<Header as="h2" icon textAlign="center">
			<Icon name="searchengin" circular />
			<Header.Content>Wyszukiwarka statusów spraw</Header.Content>
			<Header.Subheader>Wybierz jednostkę organizacyjną</Header.Subheader>
		</Header>
		<AutosuggestContainer>
			<OrganizationAutosuggest autoFocus />
		</AutosuggestContainer>
	</HomeContainer>
)

const HomeContainer = styled(Container)`
	&& {
		align-items: center;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		justify-content: center;
	}
`

const AutosuggestContainer = styled.div`
	width: 100%;
	@media screen and (min-width: ${Responsive.onlyTablet.minWidth}px) {
		width: 350px;
	}
`

export default Home



// WEBPACK FOOTER //
// ./src/containers/home/Home.js